import React from "react"

interface FormContainerProps {
    inputs: React.ReactNode
    buttons?: React.ReactNode
    className?: string
    inputsClassName?: string
    buttonsClassName?: string
}

const FormContainer = ({
    inputs,
    buttons,
    className,
    inputsClassName,
    buttonsClassName
}: FormContainerProps) => (
    <div className={className ?? "d-flex flex-column gap-3"}>
        <div className={inputsClassName ?? "row g-2"}>
            {inputs}
        </div>
        {buttons && (
            <div className={buttonsClassName ?? "d-flex gap-2"}>
                {buttons}
            </div>
        )}
    </div>
)

export default FormContainer
